<div *ngIf="czyZaladowanoDane">
  <div class="container--main d-none d-md-block">
    <div class="ft__sort text-center pt-4">{{ nazwaProjektu }}</div>

    <app-menu-projektu
      [czyPracownikKlienta]="czyPracownikKlienta()"
      [idProjektu]="idProjektu"
      [rodzajProjektu]="rodzajProjektu"
      [czyMobile]="false"
      [czyAdmin]="czyAdmin()"
      [czySpisSamodzielnyKlienta]="czySpisSamodzielnyKlienta"
      aktywnyAdres="users-statistics"
    ></app-menu-projektu>
  </div>

  <div class="container-fluid d-none d-md-block pt-2">
    <div class="box__scroll py-3">
      <div
        class="box__scroll--top d-flex justify-content-between align-items-center mb-3"
      >
        <span class="ft__03">Statystyki pracowników</span>
        <div class="input_container">
          <button
            class="btn__clear--filter"
            (click)="wyczyscFiltry()"
            *ngIf="czyPokazacWyczyscFiltry()"
          >
            Wyczyść filtry
          </button>
        </div>
      </div>
      <div class="tableFixHead tableFixHead--3">
        <table class="table">
          <thead>
            <tr>
              <th>
                Imię
                <button
                  class="btn__input--sort--bottom--gray"
                  [ngClass]="pobierzKierunekSortowania('imie')"
                  (click)="zmienKierunekSortowania('imie')"
                ></button>

                <div class="input_container input_container--mini">
                  <input
                    class="pr-4"
                    type="text"
                    placeholder="Szukaj"
                    [(ngModel)]="wyszukiwanie.filtry.imie"
                    (keyup)="filtrujPoTekscie(this.wyszukiwanie.filtry.imie)"
                  />
                  <button
                    class="btn__input--search"
                    *ngIf="!wyszukiwanie.filtry.imie"
                  ></button>
                  <button
                    class="btn__input--clear"
                    *ngIf="wyszukiwanie.filtry.imie"
                    (click)="
                      this.wyszukiwanie.filtry.imie = '';
                      pobierzDaneDoEkranu(false)
                    "
                  ></button>
                </div>
              </th>
              <th>
                Nazwisko
                <button
                  class="btn__input--sort--bottom--gray"
                  [ngClass]="pobierzKierunekSortowania('nazwisko')"
                  (click)="zmienKierunekSortowania('nazwisko')"
                ></button>

                <div class="input_container input_container--mini">
                  <input
                    class="pr-4"
                    type="text"
                    placeholder="Szukaj"
                    [(ngModel)]="wyszukiwanie.filtry.nazwisko"
                    (keyup)="
                      filtrujPoTekscie(this.wyszukiwanie.filtry.nazwisko)
                    "
                  />
                  <button
                    class="btn__input--search"
                    *ngIf="!wyszukiwanie.filtry.nazwisko"
                  ></button>
                  <button
                    class="btn__input--clear"
                    *ngIf="wyszukiwanie.filtry.nazwisko"
                    (click)="
                      this.wyszukiwanie.filtry.nazwisko = '';
                      pobierzDaneDoEkranu(false)
                    "
                  ></button>
                </div>
              </th>
              <th>
                Zespół
                <button
                  class="btn__input--sort--bottom--gray"
                  [ngClass]="pobierzKierunekSortowania('nazwa_zespolu')"
                  (click)="zmienKierunekSortowania('nazwa_zespolu')"
                ></button>

                <div class="input_container input_container--mini">
                  <input
                    class="pr-4"
                    type="text"
                    placeholder="Szukaj"
                    [(ngModel)]="wyszukiwanie.filtry.zespol"
                    (keyup)="filtrujPoTekscie(this.wyszukiwanie.filtry.zespol)"
                  />
                  <button
                    class="btn__input--search"
                    *ngIf="!wyszukiwanie.filtry.zespol"
                  ></button>
                  <button
                    class="btn__input--clear"
                    *ngIf="wyszukiwanie.filtry.zespol"
                    (click)="
                      this.wyszukiwanie.filtry.zespol = '';
                      pobierzDaneDoEkranu(false)
                    "
                  ></button>
                </div>
              </th>

              <th>
                Spisane gniazda
                <button
                  class="btn__input--sort--bottom--gray"
                  [ngClass]="pobierzKierunekSortowania('Spisane gniazda')"
                  (click)="zmienKierunekSortowania('Spisane gniazda')"
                ></button>

                <div class="input_container input_container--mini">
                  <input
                    class="pr-4"
                    type="text"
                    placeholder="Szukaj"
                    [(ngModel)]="wyszukiwanie.filtry.spisaneGniazda"
                    (keyup)="
                      filtrujPoTekscie(this.wyszukiwanie.filtry.spisaneGniazda)
                    "
                  />
                  <button
                    class="btn__input--search"
                    *ngIf="!wyszukiwanie.filtry.spisaneGniazda"
                  ></button>
                  <button
                    class="btn__input--clear"
                    *ngIf="wyszukiwanie.filtry.spisaneGniazda"
                    (click)="
                      this.wyszukiwanie.filtry.spisaneGniazda = '';
                      pobierzDaneDoEkranu(false)
                    "
                  ></button>
                </div>
              </th>

              <th>
                Spisane indeksy
                <button
                  class="btn__input--sort--bottom--gray"
                  [ngClass]="pobierzKierunekSortowania('Spisane indeksy')"
                  (click)="zmienKierunekSortowania('Spisane indeksy')"
                ></button>

                <div class="input_container input_container--mini">
                  <input
                    class="pr-4"
                    type="text"
                    placeholder="Szukaj"
                    [(ngModel)]="wyszukiwanie.filtry.spisaneIndeksy"
                    (keyup)="
                      filtrujPoTekscie(this.wyszukiwanie.filtry.spisaneIndeksy)
                    "
                  />
                  <button
                    class="btn__input--search"
                    *ngIf="!wyszukiwanie.filtry.spisaneIndeksy"
                  ></button>
                  <button
                    class="btn__input--clear"
                    *ngIf="wyszukiwanie.filtry.spisaneIndeksy"
                    (click)="
                      this.wyszukiwanie.filtry.spisaneIndeksy = '';
                      pobierzDaneDoEkranu(false)
                    "
                  ></button>
                </div>
              </th>
              <th>
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    gap: 10px;
                    align-items: end;
                  "
                >
                  <div style="display: flex; flex-direction: row; gap: 5px">
                    Spisane sztuki
                  </div>

                  <button
                    class="btn__input--sort--bottom--gray"
                    [ngClass]="pobierzKierunekSortowania('Spisane sztuki')"
                    style="margin-bottom: 5px"
                    (click)="zmienKierunekSortowania('Spisane sztuki')"
                  ></button>
                </div>

                <div class="input_container input_container--mini">
                  <input
                    class="pr-4"
                    type="text"
                    placeholder="Szukaj"
                    [(ngModel)]="wyszukiwanie.filtry.spisaneSztuki"
                    (keyup)="
                      filtrujPoTekscie(this.wyszukiwanie.filtry.spisaneSztuki)
                    "
                  />
                  <button
                    class="btn__input--search"
                    *ngIf="!wyszukiwanie.filtry.spisaneSztuki"
                  ></button>
                  <button
                    class="btn__input--clear"
                    *ngIf="wyszukiwanie.filtry.spisaneSztuki"
                    (click)="
                      this.wyszukiwanie.filtry.spisaneSztuki = '';
                      pobierzDaneDoEkranu(false)
                    "
                  ></button>
                </div>
              </th>

              <th>
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    gap: 10px;
                    align-items: end;
                  "
                >
                  <div style="display: flex; flex-direction: row; gap: 5px">
                    Spisane środki
                  </div>

                  <button
                    class="btn__input--sort--bottom--gray"
                    [ngClass]="pobierzKierunekSortowania('Spisane środki')"
                    style="margin-bottom: 5px"
                    (click)="zmienKierunekSortowania('Spisane środki')"
                  ></button>
                </div>

                <div class="input_container input_container--mini">
                  <input
                    class="pr-4"
                    type="text"
                    placeholder="Szukaj"
                    [(ngModel)]="wyszukiwanie.filtry.spisaneSrodki"
                    (keyup)="
                      filtrujPoTekscie(this.wyszukiwanie.filtry.spisaneSrodki)
                    "
                  />
                  <button
                    class="btn__input--search"
                    *ngIf="!wyszukiwanie.filtry.spisaneSrodki"
                  ></button>
                  <button
                    class="btn__input--clear"
                    *ngIf="wyszukiwanie.filtry.spisaneSrodki"
                    (click)="
                      this.wyszukiwanie.filtry.spisaneSrodki = '';
                      pobierzDaneDoEkranu(false)
                    "
                  ></button>
                </div>
              </th>
            </tr>
          </thead>
          <tbody class="fz12" *ngIf="czySaWynikiNaLiscie(pracownicy)">
            <tr
              *ngFor="let pracownik of pracownicy"
              class="pointer project-row"
            >
              <td>{{ pracownik.imie }}</td>
              <td>{{ pracownik.nazwisko }}</td>
              <td>{{ pracownik.zespol }}</td>
              <td>{{ pracownik.spisaneGniazda }}</td>
              <td>{{ pracownik.spisaneIndeksy }}</td>
              <td>{{ pracownik.spisaneSztuki }}</td>
              <td>{{ pracownik.spisaneSrodki }}</td>
            </tr>
          </tbody>
        </table>
        <div
          class="ft__03 text-gray text-center my-5 py-5"
          *ngIf="!czySaWynikiNaLiscie(pracownicy)"
        >
          <div>Brak pracowników dla wybranych filtrów</div>
        </div>
      </div>
    </div>

    <div
      class="paginate float-right d-flex align-items-center pt-4 pb-2 pt-lg-2 mt-1"
      *ngIf="czySaWynikiNaLiscie(pracownicy)"
    >
      <div>Pokaż wyniki</div>
      <select
        class="paginate__select mx-2"
        name=""
        id=""
        (change)="zmienRozmiarTabeli()"
        [(ngModel)]="rozmiarTabeli"
      >
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
      <div class="px-2">
        {{ pobierzNumerRekorduPoczatek() }}-{{ pobierzNumerRekorduKoniec() }} z
        {{ calkowitaLiczbaElementow }}
      </div>
      <div class="d-flex">
        <button
          class="btn__left"
          *ngIf="this.wyszukiwanie.stronicowanie.strona > 1"
          (click)="zmienStrone(-1)"
        ></button>
        <div class="px-2">{{ this.wyszukiwanie.stronicowanie.strona }}</div>
        <button
          class="btn__right"
          *ngIf="czyJestWiecejRekordow"
          (click)="zmienStrone(1)"
        ></button>
      </div>
    </div>
  </div>

  <!-- mobile -->
  <div class="container-fluid d-md-none pb-5">
    <div class="pt-3 mt-1">
      <div class="ft__sort text-center">{{ nazwaProjektu }}</div>
    </div>

    <app-menu-projektu
      [czyPracownikKlienta]="czyPracownikKlienta()"
      [idProjektu]="idProjektu"
      [rodzajProjektu]="rodzajProjektu"
      [czyMobile]="true"
      [czyAdmin]="czyAdmin()"
      [czySpisSamodzielnyKlienta]="czySpisSamodzielnyKlienta"
      aktywnyAdres="users-statistics"
    ></app-menu-projektu>

    <div class="filter-box d-flex justify-content-between pt-3 mb-3">
      <span class="ft__03">Statystyki pracowników</span>
      <div class="dropdown person_desktop text-right">
        <a
          class="btn__input--sort dropdown-toggle"
          [routerLink]=""
          (click)="pokazMenuSortowania()"
          role="button"
          id="dropdownSort"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          (clickOutside)="czyPokazacMenuSortowanie = false"
        >
        </a>
        <div
          class="dropdown-menu dropdown-menu-right"
          aria-labelledby="dropdownSort"
          *ngIf="czyPokazacMenuSortowanie"
          style="display: block; position: absolute"
        >
          <a
            class="dropdown-item"
            [routerLink]=""
            (click)="zmienKierunekSortowania('imie')"
            >Imię
          </a>
          <a
            class="dropdown-item"
            [routerLink]=""
            (click)="zmienKierunekSortowania('nazwisko')"
            >Nazwisko</a
          >
          <a
            class="dropdown-item"
            [routerLink]=""
            (click)="zmienKierunekSortowania('nazwa_zespolu')"
            >Zespół</a
          >
          <a
            class="dropdown-item"
            [routerLink]=""
            (click)="zmienKierunekSortowania('Spisane gniazda')"
            >Spisane gniazda</a
          ><a
            class="dropdown-item"
            [routerLink]=""
            (click)="zmienKierunekSortowania('Spisane indeksy')"
            >Spisane indeksy</a
          >
          <a
            class="dropdown-item"
            [routerLink]=""
            (click)="zmienKierunekSortowania('Spisane sztuki')"
            >Spisane sztuki</a
          >

          <a
            class="dropdown-item"
            [routerLink]=""
            (click)="zmienKierunekSortowania('Spisane środki')"
            >Spisane środki</a
          >
        </div>
      </div>
    </div>
    <div
      class="filter-select pt-3 pb-2 d-flex flex-column mb-3"
      *ngIf="pobierzKolumneSortowania()"
    >
      <div class="d-flex pb-2">
        <div class="filter_item">
          <button class="btn__x" (click)="wyczyscSortowanieMobile()"></button>
          <span class="fs__sort"
            >Sortowanie: {{ pobierzKolumneSortowania() }}</span
          >
        </div>
        <button
          class="btn__input--sort--bottom ml-3"
          [ngClass]="pobierzKierunekSortowaniaMobile()"
          (click)="zmienKierunekSortowaniaMobile()"
        ></button>
      </div>
    </div>

    <div
      class="input_container mb-3 text-right"
      *ngIf="!czyPokazanoWyszukiwarkeMobile"
    >
      <button
        class="btn__search"
        (click)="pokazWyszukiwarkeMobile(true)"
      ></button>
    </div>
    <div
      class="searchBox d-flex flex-wrap por pb-5"
      *ngIf="czyPokazanoWyszukiwarkeMobile"
    >
      <button
        class="btn__input--clear"
        (click)="pokazWyszukiwarkeMobile(false)"
      ></button>
    </div>

    <div
      class="box__mobile box__mobile--form mb-3"
      *ngIf="czyPokazanoWyszukiwarkeMobile"
    >
      <div class="input_container mb-3">
        <input
          class="pr-4"
          type="text"
          placeholder="Imię"
          [(ngModel)]="wyszukiwanie.filtry.imie"
        />
        <button
          class="btn__input--search"
          *ngIf="!wyszukiwanie.filtry.imie"
        ></button>
        <button
          class="btn__input--clear"
          *ngIf="wyszukiwanie.filtry.imie"
          (click)="this.wyszukiwanie.filtry.imie = ''"
        ></button>
      </div>
      <div class="input_container mb-3">
        <input
          class="pr-4"
          type="text"
          placeholder="Nazwisko"
          [(ngModel)]="wyszukiwanie.filtry.nazwisko"
        />
        <button
          class="btn__input--search"
          *ngIf="!wyszukiwanie.filtry.nazwisko"
        ></button>
        <button
          class="btn__input--clear"
          *ngIf="wyszukiwanie.filtry.nazwisko"
          (click)="this.wyszukiwanie.filtry.nazwisko = ''"
        ></button>
      </div>
      <div class="input_container mb-3">
        <input
          class="pr-4"
          type="text"
          placeholder="Zespół"
          [(ngModel)]="wyszukiwanie.filtry.zespol"
        />
        <button
          class="btn__input--search"
          *ngIf="!wyszukiwanie.filtry.zespol"
        ></button>
        <button
          class="btn__input--clear"
          *ngIf="wyszukiwanie.filtry.zespol"
          (click)="this.wyszukiwanie.filtry.zespol = ''"
        ></button>
      </div>
      <div class="input_container mb-3">
        <input
          class="pr-4"
          type="text"
          placeholder="Spisane gniazda"
          [(ngModel)]="wyszukiwanie.filtry.spisaneGniazda"
        />
        <button
          class="btn__input--search"
          *ngIf="!wyszukiwanie.filtry.spisaneGniazda"
        ></button>
        <button
          class="btn__input--clear"
          *ngIf="wyszukiwanie.filtry.spisaneGniazda"
          (click)="this.wyszukiwanie.filtry.spisaneGniazda = ''"
        ></button>
      </div>

      <div class="input_container mb-3">
        <input
          class="pr-4"
          type="text"
          placeholder="Spisane indeksy"
          [(ngModel)]="wyszukiwanie.filtry.spisaneIndeksy"
        />
        <button
          class="btn__input--search"
          *ngIf="!wyszukiwanie.filtry.spisaneIndeksy"
        ></button>
        <button
          class="btn__input--clear"
          *ngIf="wyszukiwanie.filtry.spisaneIndeksy"
          (click)="this.wyszukiwanie.filtry.spisaneIndeksy = ''"
        ></button>
      </div>

      <div class="input_container mb-3">
        <input
          class="pr-4"
          type="text"
          placeholder="Spisane sztuki"
          [(ngModel)]="wyszukiwanie.filtry.spisaneSztuki"
        />
        <button
          class="btn__input--search"
          *ngIf="!wyszukiwanie.filtry.spisaneSztuki"
        ></button>
        <button
          class="btn__input--clear"
          *ngIf="wyszukiwanie.filtry.spisaneSztuki"
          (click)="this.wyszukiwanie.filtry.spisaneSztuki = ''"
        ></button>
      </div>
      <div class="input_container mb-3">
        <input
          class="pr-4"
          type="text"
          placeholder="Spisane środki"
          [(ngModel)]="wyszukiwanie.filtry.spisaneSrodki"
        />
        <button
          class="btn__input--search"
          *ngIf="!wyszukiwanie.filtry.spisaneSrodki"
        ></button>
        <button
          class="btn__input--clear"
          *ngIf="wyszukiwanie.filtry.spisaneSrodki"
          (click)="this.wyszukiwanie.filtry.spisaneSrodki = ''"
        ></button>
      </div>
    </div>

    <button
      class="btn__border mt-4 mb-4"
      (click)="pobierzDaneDoEkranu(true); pokazWyszukiwarkeMobile(false)"
      *ngIf="czyPokazanoWyszukiwarkeMobile"
    >
      Szukaj
    </button>

    <button
      class="btn__clear--filter mt-2 mb-4"
      (click)="wyczyscFiltry(); pokazWyszukiwarkeMobile(false)"
      *ngIf="czyPokazacWyczyscFiltry()"
    >
      Wyczyść filtry
    </button>

    <div
      class="no-results text-center ft__no-results"
      *ngIf="!czySaWynikiNaLiscie(pracownicy)"
    >
      <div>Brak pracowników<br />dla wybranych filtrów</div>
    </div>

    <div class="box__mobile mb-3" *ngFor="let pracownik of pracownicy">
      <div
        class="d-flex justify-content-between align-items-center pb-2 mr-3 mb-2 m_border"
      >
        <span class="fs__pname--2">Imię</span>
        <span class="fs__pname--3 text-lg2">{{ pracownik.imie }}</span>
      </div>
      <div
        class="d-flex justify-content-between align-items-center pb-2 mr-3 mb-2 m_border"
      >
        <span class="fs__pname--2">Nazwisko</span>
        <span class="fs__pname--3 text-lg2">{{ pracownik.nazwisko }}</span>
      </div>
      <div
        class="d-flex justify-content-between align-items-center pb-2 mr-3 mb-2 m_border"
      >
        <span class="fs__pname--2">Zespół</span>
        <span class="fs__pname--3 text-lg2">{{ pracownik.zespol }}</span>
      </div>
      <div
        class="d-flex justify-content-between align-items-center pb-2 mr-3 mb-2 m_border"
      >
        <span class="fs__pname--2">Spisane gniazda</span>
        <span class="fs__pname--3 text-lg2">{{
          pracownik.spisaneGniazda
        }}</span>
      </div>
      <div
        class="d-flex justify-content-between align-items-center pb-2 mr-3 mb-2 m_border"
      >
        <span class="fs__pname--2">Spisane indeksy</span>
        <span class="fs__pname--3 text-lg2">{{
          pracownik.spisaneIndeksy
        }}</span>
      </div>
      <div
        class="d-flex justify-content-between align-items-center pb-2 mr-3 mb-2 m_border"
      >
        <span class="fs__pname--2">Spisane sztuki</span>
        <span class="fs__pname--3 text-lg2">{{ pracownik.spisaneSztuki }}</span>
      </div>
      <div
        class="d-flex justify-content-between align-items-center pb-2 mr-3 mb-2 m_border"
      >
        <span class="fs__pname--2">Spisane środki</span>
        <span class="fs__pname--3 text-lg2">{{ pracownik.spisaneSrodki }}</span>
      </div>
    </div>

    <div
      class="paginate float-right d-flex align-items-center pb-2 pt-lg-4"
      *ngIf="czySaWynikiNaLiscie(pracownicy)"
    >
      <div>Pokaż wyniki</div>
      <select
        class="paginate__select mx-2"
        name=""
        id=""
        (change)="zmienRozmiarTabeli()"
        [(ngModel)]="rozmiarTabeli"
      >
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
      <div class="px-2">
        {{ pobierzNumerRekorduPoczatek() }}-{{ pobierzNumerRekorduKoniec() }} z
        {{ calkowitaLiczbaElementow }}
      </div>
      <div class="d-flex">
        <button
          class="btn__left"
          *ngIf="this.wyszukiwanie.stronicowanie.strona > 1"
          (click)="zmienStrone(-1)"
        ></button>
        <div class="px-2">{{ this.wyszukiwanie.stronicowanie.strona }}</div>
        <button
          class="btn__right"
          *ngIf="czyJestWiecejRekordow"
          (click)="zmienStrone(1)"
        ></button>
      </div>
    </div>
    <button
      class="btn__border btn__border--mini px-3 mt-3"
      (click)="eksportujDane()"
    >
      Eksportuj dane
    </button>
    <button
      class="btn__link order-1 order-sm-0"
      (click)="cofnij()"
      *ngIf="!czyPracownikKlienta()"
    >
      Cofnij
    </button>
  </div>

  <div class="bootom__buttons px-4 d-none d-md-block">
    <div
      class="container--mw600 flex-column flex-sm-row d-flex justify-content-between align-items-center"
    >
      <button
        class="btn__link order-1 order-sm-0"
        (click)="cofnij()"
        *ngIf="!czyPracownikKlienta()"
      >
        Cofnij
      </button>
      <button
        class="btn__border btn__border--mini px-3"
        (click)="eksportujDane()"
      >
        Eksportuj dane
      </button>
    </div>
  </div>
</div>
